/**
 * Decide how many decimals to show for a token **amount** (size), based on the token price.
 *
 * Rationale: when token price is small, sizes tend to be large and showing many decimals adds noise.
 * Conversely, for expensive tokens, sizes are often fractional and need more precision.
 */
export const getTokenSizeDisplayDecimals = (price: number): number => {
  if (!isFinite(price) || price === 0 || price === 1) return 2;

  // cheap tokens: keep it simple
  if (price < 0.1) return 0;
  if (price < 1) return 1;
  if (price < 10) return 2;
  if (price < 100) return 3;
  if (price < 1000) return 4;
  if (price < 10000) return 5;

  // very expensive tokens: show more fractional precision
  return 6;
};


